/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClaimStats
 */
export interface ClaimStats {
    /**
     * 
     * @type {number}
     * @memberof ClaimStats
     */
    total?: number;
    /**
     * Map of status template display name → count.
     * @type {{ [key: string]: number; }}
     * @memberof ClaimStats
     */
    byStatusTemplate?: { [key: string]: number; };
    /**
     * Map of lossType → count.
     * @type {{ [key: string]: number; }}
     * @memberof ClaimStats
     */
    byLossType?: { [key: string]: number; };
}

/**
 * Check if a given object implements the ClaimStats interface.
 */
export function instanceOfClaimStats(value: object): value is ClaimStats {
    return true;
}

export function ClaimStatsFromJSON(json: any): ClaimStats {
    return ClaimStatsFromJSONTyped(json, false);
}

export function ClaimStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimStats {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'] == null ? undefined : json['total'],
        'byStatusTemplate': json['byStatusTemplate'] == null ? undefined : json['byStatusTemplate'],
        'byLossType': json['byLossType'] == null ? undefined : json['byLossType'],
    };
}

export function ClaimStatsToJSON(json: any): ClaimStats {
    return ClaimStatsToJSONTyped(json, false);
}

export function ClaimStatsToJSONTyped(value?: ClaimStats | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': value['total'],
        'byStatusTemplate': value['byStatusTemplate'],
        'byLossType': value['byLossType'],
    };
}

